import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";
import { ActivityKind } from "./activity-kind";
import { ActivityType } from "./activity-type";
import { ObjectLayer } from "./object-layer";
import { ObjectType } from "./object-type";
import { DbObjectCreateOrUpdateInfos } from "./db-object-create-or-update-infos";

export class DbActivityInfos extends DbMongoSerializationBaseInfos {
  platformId: number = 0;
  userId: number | null = null;
  resId: number = 0;
  kind: ActivityKind = ActivityKind.Action; // default is first of enum, always returned by backend
  type: ActivityType = ActivityType.ApprovalAccept; // default is first of enum, always returned by backend
  typeExp: string = "";
  date: Date = new Date();
  ip: string | null = null;
  msg: string | null = null;
  objName: string = "";
  replyId: number | null = 0;
  solved: DbObjectCreateOrUpdateInfos | null = null;
  assetObjectType: ObjectType | null = null;
  assetObjectLayer: ObjectLayer | null = null;
  userName: string | null = null;
  isRead: boolean = false;

  constructor(init?: Partial<DbActivityInfos>) {
    super();
    Object.assign(this, init);
  }
}
